import { render, staticRenderFns } from "./vTaskCreate.vue?vue&type=template&id=09d153e4&"
import script from "./vTaskCreate.vue?vue&type=script&lang=js&"
export * from "./vTaskCreate.vue?vue&type=script&lang=js&"
import style0 from "./vTaskCreate.vue?vue&type=style&index=0&id=09d153e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports